
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expertise/engineering",
      function () {
        return require("private-next-pages/expertise/engineering.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expertise/engineering"])
      });
    }
  